import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { backAction } from 'actions/workflow';
import Button from './Button';

const BackButton = ({ isDisabled, onFail, onBeforeBack, className = '' }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoadingBack, setIsLoadingBack] = useState(false);

  const handleBack = (e) => {
    e.preventDefault();
    onBeforeBack?.();
    setIsLoadingBack(true);

    dispatch(backAction({
      key: searchParams.get('key'),
      data: {},
      success: (res) => {
        setIsLoadingBack(false);
        navigate(get(res, 'data.url'));
      },
      fail: (err) => {
        setIsLoadingBack(false);
        onFail(err);
      },
    }));
  };

  return (
    <Button
      className={className}
      label="Back"
      modifier="outline"
      arrow="left"
      isLoading={isLoadingBack}
      onClick={handleBack}
      isDisabled={isDisabled}
    />
  );
};

BackButton.propTypes = {
  onFail: PropTypes.func.isRequired,
  onBeforeBack: PropTypes.func,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
};

BackButton.defaultProps = {
  className: '',
  onBeforeBack: () => {},
  isDisabled: false,
};

export default BackButton;